import { useCallback, useState } from "react";

export const useAppUpdate = () => {
  const [isRefreshing, setIsRefreshing] = useState(false);

  const refreshApp = useCallback(async () => {
    setIsRefreshing(true);
    try {
      if ("serviceWorker" in navigator) {
        const registration = await navigator.serviceWorker.getRegistration();
        // update() は Service Worker スクリプトの取得時に HTTP キャッシュを無視するため、
        // インストール済み PWA でも最新版を確実に検知できる
        await registration?.update();
      }
    } catch (error) {
      console.error("Service worker の更新確認に失敗しました:", error);
    } finally {
      window.location.reload();
    }
  }, []);

  return { refreshApp, isRefreshing };
};
